const mapStateToProps = (state) =>{
    const {
        service:{
            Geozone:{
                resetVertex,
                deleteLastVertex,
                saveGeozonePolygone,
            }={}
        }={},
        api:{
            savingGeoObjGeozone,
        }={},
        geozone:{
            geozoneVertexArr,
            geozoneArr,
        }={},
        user:{
            rights,
        }={},
    } = state;
    return {
        resetVertex,
        deleteLastVertex,
        saveGeozonePolygone,
        savingGeoObjGeozone,
        geozoneVertexArr,
        geozoneArr,
        rights,
    }
}

export default mapStateToProps;